import { render, staticRenderFns } from "./orderNum.vue?vue&type=template&id=5553d55d&scoped=true&"
import script from "./orderNum.vue?vue&type=script&lang=js&"
export * from "./orderNum.vue?vue&type=script&lang=js&"
import style0 from "./orderNum.vue?vue&type=style&index=0&id=5553d55d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5553d55d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5553d55d')) {
      api.createRecord('5553d55d', component.options)
    } else {
      api.reload('5553d55d', component.options)
    }
    module.hot.accept("./orderNum.vue?vue&type=template&id=5553d55d&scoped=true&", function () {
      api.rerender('5553d55d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderDetail/comp/orderNum.vue"
export default component.exports